var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.777771,
    y: 0.400024,
    width: 35.4444,
    height: 35.2,
    rx: 15,
    fill: "url(#paint0_linear_1061_6968)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.405 10H11.8155C10.1944 10 8.86796 11.2871 8.85056 12.9082C8.81445 16.2719 8.84214 20.3484 8.86974 23.0494C8.88649 24.6883 10.2177 26 11.8567 26C15.2155 26 20.7943 26 25.1694 26C26.8262 26 28.1667 24.6569 28.1667 23V17C28.1667 15.3431 26.8235 14 25.1667 14H11.7754",
    stroke: "#361D49",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0555 20C26.0555 20.8252 25.381 21.5 24.5417 21.5C23.7023 21.5 23.0278 20.8252 23.0278 20C23.0278 19.1748 23.7023 18.5 24.5417 18.5C25.381 18.5 26.0555 19.1748 26.0555 20Z",
    fill: "#351D47",
    stroke: "#361D49"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1061_6968",
    x1: 35.3783,
    y1: 18,
    x2: 1.62169,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletActive);
export default __webpack_public_path__ + "static/media/wallet-active.26a2485d130a1baccba08dcec8151db3.svg";
export { ForwardRef as ReactComponent };